'use client'

import React, { createContext, ReactNode, useContext } from 'react'

import type { DestinationPageResponse } from '@/src/types/destinationResult'

interface DestinationContextType {
    destinationData: DestinationPageResponse
}

const initialState: DestinationContextType = {
    destinationData: {
        meta: { contentMode: 'legacy', locale: 'en' },
        head: {
            title: '',
            description: '',
            keywords: [],
            canonicalUrl: '',
            openGraph: {},
            twitter: {},
            robots: { index: false, follow: true },
            jsonLd: []
        },
        sections: {
            hero: {
                heading: '',
                subheading: null,
                cityName: '',
                countryName: '',
                stats: { topOrigins: [], topAirlines: [], weeklyArrivals: 0 }
            },
            destinationInfo: null,
            placesToVisit: [],
            thingsToDo: [],
            areasToStay: [],
            climate: null,
            costOfLiving: null,
            quickFacts: null,
            topHotels: [],
            popularRoutes: [],
            faq: [],
            editorialMeta: null
        },
        footer: { topAirlines: [], topDestinations: [], topRoutes: [] }
    }
}

const DestinationContext = createContext<DestinationContextType>(initialState)

interface DestinationProviderProps {
    children: ReactNode
    data: DestinationPageResponse
}

export const DestinationProvider: React.FC<DestinationProviderProps> = ({ children, data }) => {
    return (
        <DestinationContext.Provider value={{ destinationData: data }}>
            {children}
        </DestinationContext.Provider>
    )
}

export const useDestinationContext = () => useContext(DestinationContext)

export { DestinationContext }
